import script from "./DevicesLotView.vue?vue&type=script&setup=true&lang=js"
export * from "./DevicesLotView.vue?vue&type=script&setup=true&lang=js"

import "./DevicesLotView.vue?vue&type=style&index=0&id=2f8dfa4a&scoped=true&lang=css"
import "./DevicesLotView.vue?vue&type=style&index=1&id=2f8dfa4a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f8dfa4a"]])

export default __exports__